module.exports = __webpack_public_path__ + "static/img/instoreBanner.406d50d6.jpg";